// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2ciO-","search":"Settings_search__1PCGT","filter":"Settings_filter__3IA9T"};